import {noop} from 'lodash';
import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {getCellBackgroundColor, getCellIndexStyles} from '../helpers/tableCellHelpers';
import {getWidthSettingsStyles} from '../tableColumn';
import {TableCell, TableCellProps, TableCellStyleProps} from './tableCell';

/*
 * Props.
 */

interface ChildrenCellProps extends TableCellProps<{}> {
  hasPadding?: boolean;
}

/*
 * Style.
 */

export const StyledCellChildrenWrapperDiv = styled.div<TableCellStyleProps & {$hasPadding?: boolean}>`
  display: flex;
  align-items: center;
  height: 100%;

  ${(p) => getCellBackgroundColor(p.$isHovering, p.$isSelected)}
  ${(p) => getWidthSettingsStyles(p.$settings?.cellWidth, p.$index)}
  ${(p) =>
    getCellIndexStyles(
      p.$index,
      p.$isSelected,
      p.$shouldRemoveTopBorderRadius,
      p.$shouldRemoveBottomBorderRadius,
      p.$shouldRemoveLeftBorderRadius,
    )};
  ${(p) => (p.$hasPadding ? 'padding: 0 12px;' : '')};
`;

/*
 * Component.
 */

export const ChildrenCell: FC<PropsWithChildren<ChildrenCellProps>> = (props) => {
  const {
    isSelected,
    isHovering,
    isLoading,
    size,
    settings,
    index,
    shouldShowStickyGradient,
    shouldRemoveTopBorderRadius,
    shouldRemoveBottomBorderRadius,
    hasPadding,
  } = props;

  return (
    <TableCell<any>
      isSelected={isSelected}
      isHovering={isHovering}
      isLoading={isLoading}
      size={size}
      settings={settings}
      index={index}
      value={noop}
      shouldShowStickyGradient={shouldShowStickyGradient}
      shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
      shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
      renderCell={() => (
        <StyledCellChildrenWrapperDiv
          $settings={settings}
          $isHovering={Boolean(isHovering)}
          $index={index}
          $isSelected={Boolean(isSelected)}
          $shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
          $shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
          $hasPadding={hasPadding}
        >
          {props.children}
        </StyledCellChildrenWrapperDiv>
      )}
    />
  );
};
